import React from 'react';
import { motion } from 'framer-motion';
import styles from './FloatingActionButton.module.css';

const FloatingActionButton = ({ onClick, isProfilePanelOpen }) => {
  // Don't render the button if the profile panel is open
  if (isProfilePanelOpen) {
    return null;
  }

  return (
    <motion.button
      className={styles.fab}
      onClick={onClick}
      whileHover={{ scale: 1.15 }}
      whileTap={{ scale: 0.9 }}
      animate={{ 
        scale: [1, 1.05, 1],
        boxShadow: [
          "0 4px 20px rgba(33, 150, 243, 0.3)",
          "0 6px 25px rgba(33, 150, 243, 0.4)",
          "0 4px 20px rgba(33, 150, 243, 0.3)"
        ]
      }}
      transition={{ 
        duration: 2,
        repeat: Infinity,
        repeatDelay: 8
      }}
      aria-label="Edit Academic Profile"
      role="button"
    >
      {/* Pen/Edit SVG Icon */}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 6L17.5 10L7 20.5L3 21.5L4 17.5L13.5 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 3L21 8L17.5 11.5L12.5 6.5L16 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </motion.button>
  );
};

export default FloatingActionButton;
